import type { Polygon } from "geojson";

const EARTH_RADIUS = 6371008.8;

/** A circle of `radius` metres as a closed GeoJSON ring of `points` corners, for MapLibre's fill and line layers. */
export function circlePolygon(
  latitude: number,
  longitude: number,
  radius: number,
  points = 64,
): Polygon {
  const lat = (latitude * Math.PI) / 180;
  const lng = (longitude * Math.PI) / 180;
  const distance = radius / EARTH_RADIUS;
  const ring = Array.from({ length: points }, (_, index) => {
    const bearing = (2 * Math.PI * index) / points;
    const pointLat = Math.asin(
      Math.sin(lat) * Math.cos(distance) +
        Math.cos(lat) * Math.sin(distance) * Math.cos(bearing),
    );
    const pointLng =
      lng +
      Math.atan2(
        Math.sin(bearing) * Math.sin(distance) * Math.cos(lat),
        Math.cos(distance) - Math.sin(lat) * Math.sin(pointLat),
      );
    return [(pointLng * 180) / Math.PI, (pointLat * 180) / Math.PI];
  });
  return { type: "Polygon", coordinates: [[...ring, ring[0]]] };
}

/** The circle's bounding box as [[west, south], [east, north]]. */
export function circleBounds(
  latitude: number,
  longitude: number,
  radius: number,
): [[number, number], [number, number]] {
  const dLat = (radius / EARTH_RADIUS) * (180 / Math.PI);
  const dLng = dLat / Math.cos((latitude * Math.PI) / 180);
  return [
    [longitude - dLng, latitude - dLat],
    [longitude + dLng, latitude + dLat],
  ];
}
